import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../ColorPsychology.css'; // Reusing the same CSS file

const ColorPsychologyOutline = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    { id: 'what-is-color-psych', title: 'What is Color Psychology?', path: '/' },
    { id: 'color-theory', title: 'Color Theory', path: '/' },
    { id: 'science-of-colors', title: 'The Science of Colors', path: '/' },
    { id: 'color-schemes', title: 'Color Schemes', path: '/' },
    { id: 'meaning-of-color', title: 'Meaning of Color', path: '/' },
    { id: 'colors-emotions', title: 'Colors and Emotions', path: '/' },
    { id: 'visual-hierarchy', title: 'Visual Hierarchy', path: '/' },
    { id: 'ui-color-map', title: 'UI Color Psychology Map', path: '/' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">Color Psychology</h1>
            <p className="course-subtitle">Understand how colors influence perception and behavior</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fas fa-fill-drip me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-play me-2"></i>
                Explore Color Psychology
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default ColorPsychologyOutline;